import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _CopyAlt(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeWidth: 2, d: "M15 3H9a4 4 0 0 0-4 4v8" }),
            React.createElement("path", { stroke: "currentColor", strokeWidth: 2, d: "M13.5 7c1.196 0 2.01.002 2.628.071.598.068.889.188 1.09.342q.208.16.369.37c.154.2.274.491.342 1.09.07.617.071 1.431.071 2.627v4c0 1.196-.002 2.01-.071 2.628-.068.598-.188.889-.342 1.09q-.16.208-.37.369c-.2.154-.491.274-1.09.342-.617.07-1.431.071-2.627.071s-2.01-.002-2.628-.071c-.598-.068-.889-.188-1.09-.342a2 2 0 0 1-.369-.37c-.154-.2-.274-.491-.342-1.09C9.001 17.51 9 16.697 9 15.5v-4c0-1.196.002-2.01.071-2.628.068-.598.188-.889.342-1.09a2 2 0 0 1 .37-.369c.2-.154.491-.274 1.09-.342C11.49 7.001 12.303 7 13.5 7Z" })));
}
const CopyAlt = forwardRef(_CopyAlt);
export { CopyAlt };
